<div mat-dialog-content class="tos-mat-dialog-content" role="dialog" aria-labelledby="prompt-dialog-title">
    <div class="restriction-box">
        <div class="box-boder">
            <h2 id="prompt-dialog-title" class="sr-only">Restriction Notice</h2>
            <app-locale localeKey="RESTRICTION" localeView="{{view}}"></app-locale>
            <div class="buttons-flex-center">
                <button type="button" class="btn btn-primary btn-group" (click)="onContinueOptAction(true)"
                    aria-label="Continue with restriction">
                    <app-locale localeKey='RESTRICTION_BTN' localeView="{{view}}"></app-locale>
                </button>
                <button type="button" class="btn btn-success btn-group" (click)="onContinueOptAction(false)"
                    aria-label="Cancel and return">
                    <app-locale localeKey='CANCEL_BTN' localeView="IFRAME"></app-locale>
                </button>
            </div>
        </div>
    </div>
</div>